module.exports = __webpack_public_path__ + "img/prdays-logo-2023.cb64e0b2.svg";